// extracted by mini-css-extract-plugin
export default {"Btn":"FancyBtn_Btn__KHu-2"};